import { FC, useState } from "react"
import PrimaryButton from "../../../../global/components/buttons/primary-button/PrimaryButton"
import { IRefreshCounterProps } from '../../../../vans/main/VansMain'
import SmallPartSuppliesModal from '../../small-part-supplies-modal/container/SmallPartSuppliesModal'

const NewSmallPartSupply: FC<IRefreshCounterProps> = (refresh: IRefreshCounterProps) => {
	const [open, setOpen] = useState(false)

	const handleOpen = () => {
		setOpen(true)
	}

	const handleClosed = () => {
		setOpen(false)
	}

	return (
		<div>
			<PrimaryButton
				buttonName='Create'
				onClick={handleOpen}
			/>
			{open && (
				<SmallPartSuppliesModal
					isOpen={open}
					handleClosed={handleClosed}
					refresh={refresh}
					smallPartSuppliesRowData={{}}
				/>
			)}
		</div>
	)
}

export default NewSmallPartSupply